<!-- Card is the panel's outermost element so the gutters match the sibling tab panes, which render a
     bare `card mb-4` of their own. (DEV-2663) -->
<div class="card mb-4">
  <div class="border-bottom">
    <h4 class="my-2 mx-3 py-2 text-primary">{{ title() }}</h4>
  </div>

  <!-- Below md the side column has nowhere to sit without pushing every setting off the first
       screen, so the sub-nav becomes the same overflow tab strip the profile headers use (DEV-974). -->
  <div class="border-bottom d-md-none">
    <ms-responsive-tabs [navItems]="tabNavItems()" (tabChanged)="onTabClick($event)" />
  </div>

  <div class="row g-0">
    <!-- Left Navigation Panel -->
    <div class="col-12 col-md-3 border-end d-none d-md-block">
      <div class="nav flex-column nav-pills p-3" role="tablist">
        @for (item of filteredNavItems(); track item.id) {
          <button
            class="nav-link text-start text-primary rounded mb-2 d-flex align-items-center justify-content-between gap-2"
            [class.active]="isActive(item.id)"
            [class.split-active-nav-item-bg]="isActive(item.id)"
            (click)="onTabClick(item.id)"
            type="button">
            <span>{{ item.label }}</span>
            @if (item.badge) {
              <span class="badge {{ item.badge.styleClass }}">{{ item.badge.label }}</span>
            }
          </button>
        }
      </div>
    </div>

    <!-- Right Content Panel -->
    <div class="col-12 col-md-9">
      <div class="p-4">
        @for (item of filteredNavItems(); track item.id) {
          @if (isActive(item.id)) {
            <div class="tab-content">
              <ng-container *ngTemplateOutlet="getTemplateForTab(item.id)"></ng-container>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
